<script lang="ts">
    import MainLayout from "../#common/layout/Layout.svelte"
    import Alert from 'src/components/main/#common/alert/Alert.svelte'
    import {showAlert} from "src/components/main/#common/alert/store"
    import googlePlay from 'src/components/main/#assets/google-play.svg'
    import cryptoCats from 'src/components/main/#assets/game-merge-cats.jpg'
    import cryptoDragons from 'src/components/main/#assets/game-crypto-dragons.jpg'
    import cryptoFox from 'src/components/main/#assets/game-crypto-fox.jpg'
    import cryptoDoge from 'src/components/main/#assets/game-crypto-doge.jpg'
    import elonGame from 'src/components/main/#assets/game-elon-game.jpg'
    import cryptoPepe from 'src/components/main/#assets/crypto-pepe-game.jpg'

    export let userId

    let googlePlayLink = 'https://play.google.com/store/apps/details?id='
    let isValidUserId = /^(U[A-Z][0-9a-zA-Z]*)$/.test(userId)
    let referralLink = isValidUserId ? '&referrer='+userId : ''
    if (isValidUserId) {
        localStorage.setItem('referral', userId)
    }

    if (!isValidUserId) {
        showAlert.set({
            status: 'error',
            text: 'Referral link is invalid, rewards will not be credited.'
        })
    }
</script>

<svelte:head>
    <title>Realis games</title>
</svelte:head>

<MainLayout>
    <svelte:fragment slot="content">
        <div class="panel-wrapper">
            <div class="container">
                <Alert />
                <div class="title">Select game</div>
                <div class="row">
                    <div class="col-6 col-lg-4 col-xl-3">
                        <div class="game-wrapper">
                            <a href="{googlePlayLink}com.soul.merge.cat.cute.simulator.adventure{referralLink}"
                                target="_blank" class="game-card">
                                <img src="{cryptoCats}" class="game-image" alt="Crypto Cats">
                                <div class="name">Crypto Cats</div>
                                <img src="{googlePlay}" class="button" alt="google play">
                            </a>
                        </div>
                    </div>
                    <div class="col-6 col-lg-4 col-xl-3">
                        <div class="game-wrapper">
                            <a href="{googlePlayLink}com.dragons.tokens.crypto{referralLink}"
                                target="_blank" class="game-card">
                                <img src="{cryptoDragons}" class="game-image" alt="Crypto Dragons">
                                <div class="name">Crypto Dragons</div>
                                <img src="{googlePlay}" class="button" alt="google play">
                            </a>
                        </div>
                    </div>
                    <div class="col-6 col-lg-4 col-xl-3">
                        <div class="game-wrapper">
                            <a href="{googlePlayLink}com.realis.fox.nft.token{referralLink}"
                                target="_blank" class="game-card">
                                <img src="{cryptoFox}" class="game-image" alt="Crypto Fox">
                                <div class="name">Crypto Fox</div>
                                <img src="{googlePlay}" class="button" alt="google play">
                            </a>
                        </div>
                    </div>
                    <div class="col-6 col-lg-4 col-xl-3">
                        <div class="game-wrapper">
                            <a href="{googlePlayLink}elon.musk.doge.meme.blockchain.coin.twit{referralLink}"
                                target="_blank" class="game-card">
                                <img src="{cryptoDoge}" class="game-image" alt="Crypto DOGE">
                                <div class="name">Crypto DOGE</div>
                                <img src="{googlePlay}" class="button" alt="google play">
                            </a>
                        </div>
                    </div>
                    <div class="col-6 col-lg-4 col-xl-3">
                        <div class="game-wrapper">
                            <a href="{googlePlayLink}com.realis.elon.nft.token{referralLink}"
                               target="_blank" class="game-card">
                                <img src="{elonGame}" class="game-image" alt="Elon Game">
                                <div class="name">Elon Game</div>
                                <img src="{googlePlay}" class="button" alt="google play">
                            </a>
                        </div>
                    </div>
                    <div class="col-6 col-lg-4 col-xl-3">
                        <div class="game-wrapper">
                            <a href="{googlePlayLink}pepecoin.frog.pepe.meme.blockchain.coin{referralLink}"
                               target="_blank" class="game-card">
                                <img src="{cryptoPepe}" class="game-image" alt="Crypto Pepe">
                                <div class="name">Crypto Frepe</div>
                                <img src="{googlePlay}" class="button" alt="google play">
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </svelte:fragment>
</MainLayout>

<style>
    .container {
        position: relative;
    }

    .title {
        font-family: 'Anton', sans-serif;
        font-size: 70px;
        font-weight: 400;
        color: white;
        margin: 0 0 40px;
        line-height: 90px;
        text-align: center;
    }

    .game-wrapper {
        border-radius: 20px;
        margin-bottom: 24px;
        background: linear-gradient(180deg, #963cfd, #2fa4fd);
        padding: 1px;
    }

    .game-card {
        border-radius: 20px;
        background: #2c252b;
        padding: 10px;
        display: block;
        text-decoration: none;
    }

    .game-image {
        max-width: 100%;
        width: 100%;
        height: auto;
        border-radius: 10px;
    }

    .name {
        text-decoration: none;
        color: white;
        text-align: center;
        font-family: 'Anton', sans-serif;
        font-size: 30px;
        font-style: normal;
        line-height: 150%;
        letter-spacing: 2px;
        margin: 15px 0 20px;
        font-weight: 400;
    }

    .button {
        max-width: 194px;
        margin: 0 auto 20px;
        display: block;
        transition: .2s;
    }

    .button:active {
        transform: translateY(2px);
    }

    @media(max-width: 1199px) {
        .title {
            font-size: 50px;
            line-height: 70px;
        }
    }

    @media (max-width: 992px) {
        .title {
            font-size: 50px;
            line-height: 70px;
            margin: 0 0 40px;
        }
    }

    @media (max-width: 767px) {
        .title {
            font-size: 40px;
            line-height: 60px;
            margin: 30px 0;
        }

        .name {
            font-size: 18px;
            line-height: 24px;
            margin: 15px 0 12px;
            letter-spacing: 1px;
        }

        .button {
            max-width: 100%;
            margin: 0 auto;
        }
    }
</style>
